import React from 'react'
import { PHSHeader } from '../../components/UI/header'
import { styles } from './index.sass'
import { Tabs } from 'antd'
import { PowerList } from '../powerList'
import { ApeironBlog } from '../apeiron-blog'
import { Rundown } from '../rundown'

const { TabPane } = Tabs

export const ContentGeneration = () => {
    return (
        <div className={styles}>
            <PHSHeader hideBreadCrumb={true} hideSubHeader={true} />
            <div className="container">
                <h1>Content Generation</h1>
                <Tabs defaultActiveKey="power-list" type="line">
                    <TabPane tab="Power List" key="power-list">
                        <PowerList />
                    </TabPane>
                    <TabPane tab="Rundown" key="rundown">
                        <Rundown />
                    </TabPane>
                    <TabPane tab="Apeiron Blog" key="apeiron-blog">
                        <ApeironBlog />
                    </TabPane>
                </Tabs>
            </div>
        </div>
    )
}
